import { HttpClient } from '@packages/core/http';
import { Bmis } from '@packages/models/api';
import { BmisResponseDto } from '@packages/models/api/bmis';
import { mapValues, pickBy } from 'lodash';

export interface FetchBmisOptions {
    vin?: string;
    ignoreCache?: boolean;
    page?: number;
    size?: number;
    orderBy?: keyof Bmis;
    orderByDirection?: 'asc' | 'desc';
}

export class BmisService {
    constructor(private http: HttpClient) {}

    async fetchBmis(options: FetchBmisOptions): Promise<Bmis[]> {
        const {
            vin,
            ignoreCache = false,
            size,
            page = 0,
            orderByDirection = 'desc',
            orderBy = 'ServiceDateandTime',
        } = options;

        const queryParams = mapValues(
            pickBy(
                { filter: vin, orderBy, orderByDirection, page, size },
                (value) => value !== null && value !== undefined
            ),
            String
        );

        const query = new URLSearchParams(queryParams).toString();

        const response = await this.http.orchestrateRequest<BmisResponseDto>({
            method: 'GET',
            url: `/bmis/retrieveVinDetails?${query}`,
            ignoreCache,
        });

        if (!response.success && response.aborted) {
            return [];
        } else if (!response.success) {
            return Promise.reject(response.data);
        }

        if (!response?.data?.tests?.length) {
            return [];
        }

        return response.data.tests;
    }
}
